import React from 'react';
import PropTypes from 'prop-types';
import Button from 'zignal-landscape/lib/Button';
import Styles from './themes/BulkEditionBar.css';

const BulkEditionBar = ({ count, isVisible, onNext, onCancel }) => {
  return isVisible ? (
    <div className={Styles.bar} data-cy="bulk-edition-bar">
      <div className={Styles.barTitle}>
        Welcome to Bulk Edit Mode! Select at least 2 widgets to begin!
      </div>
      <div className={Styles.barCount} data-cy="bulk-edition-bar-count">
        {count} Widgets Selected
      </div>
      <div className={Styles.barControls}>
        <a onClick={onCancel} data-cy="bulk-edition-bar-cancel">
          Cancel
        </a>
        <Button
          disabled={count < 2}
          onClick={onNext}
          data-cy="bulk-edition-bar-next"
        >
          Next
        </Button>
      </div>
    </div>
  ) : null;
};

BulkEditionBar.propTypes = {
  count: PropTypes.number.isRequired,
  isVisible: PropTypes.bool,
  onNext: PropTypes.func,
  onCancel: PropTypes.func
};

export default BulkEditionBar;
